<div *ngIf="partner" class="container" [ngClass]="getGeneralClass()">
    <div class="internalcard">
        <div class="data">
            <!-- TÍTOL -->
            <div class="line item-title">
                {{partner.partnerKey}}
            </div>
            <div class="line description">
                {{messageDescription | translate}}
            </div>
            <div class="line help-text">
                {{messageHelp | translate}}
            </div>
        </div>

    </div>
</div>